module.exports = __webpack_public_path__ + "img/success_header_icon_full.bdb59612.svg";